module.exports = __webpack_public_path__ + "img/gigbridge.d54fa650.svg";